module.exports = __webpack_public_path__ + "img/img21.1009164c.svg";